// extracted by mini-css-extract-plugin
module.exports = {"heroSection":"UgpgHero_heroSection__GeJuM","topHeader":"UgpgHero_topHeader__277Zy","subHeader":"UgpgHero_subHeader__2IyWk"};